import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isFileNode, $isImagesGalleryNode, $isMentionNode, $isSingleImageNode } from "../../nodes/index.js";
const TrackMediaIdsAndMentionsPlugin = (t0)=>{
    const $ = c(11);
    const { setMediaIds, setMentionsData } = t0;
    const [editor] = useLexicalComposerContext();
    let t1;
    if ($[0] !== editor) {
        t1 = ()=>editor.getEditorState().read(()=>{
                const nodes = editor.getEditorState()._nodeMap;
                const ids = [];
                nodes.forEach((node)=>{
                    if ($isSingleImageNode(node)) ids.push(node.getId());
                    if ($isImagesGalleryNode(node)) {
                        const galleryNodeIds = node.getIds();
                        galleryNodeIds.forEach((id)=>{
                            ids.push(id);
                        });
                    }
                    if ($isFileNode(node)) ids.push(node.getId());
                });
                return ids;
            });
        $[0] = editor;
        $[1] = t1;
    } else t1 = $[1];
    const getAllMediaIds = t1;
    let t2;
    if ($[2] !== editor) {
        t2 = ()=>editor.getEditorState().read(()=>{
                const nodes_0 = editor.getEditorState()._nodeMap;
                const ids_0 = [];
                nodes_0.forEach((node_0)=>{
                    if ($isMentionNode(node_0)) {
                        const mentionsData = node_0.getMentionData();
                        if (mentionsData.id && mentionsData.type) ids_0.push(mentionsData);
                    }
                });
                return ids_0;
            });
        $[2] = editor;
        $[3] = t2;
    } else t2 = $[3];
    const getAllMentionsData = t2;
    let t3;
    let t4;
    if ($[4] !== editor || $[5] !== getAllMediaIds || $[6] !== getAllMentionsData || $[7] !== setMediaIds || $[8] !== setMentionsData) {
        t3 = ()=>{
            const unsubscribe = editor.registerUpdateListener(()=>{
                const newIds = getAllMediaIds();
                const mentionsData_0 = getAllMentionsData();
                setMediaIds((prevIds)=>{
                    if (JSON.stringify(prevIds) === JSON.stringify(newIds)) return prevIds;
                    return newIds;
                });
                setMentionsData((prevMentionsData)=>{
                    if (JSON.stringify(prevMentionsData) === JSON.stringify(mentionsData_0)) return prevMentionsData;
                    return mentionsData_0;
                });
            });
            return ()=>unsubscribe();
        };
        t4 = [
            editor,
            getAllMediaIds,
            getAllMentionsData,
            setMediaIds,
            setMentionsData
        ];
        $[4] = editor;
        $[5] = getAllMediaIds;
        $[6] = getAllMentionsData;
        $[7] = setMediaIds;
        $[8] = setMentionsData;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    useEffect(t3, t4);
    return null;
};
export { TrackMediaIdsAndMentionsPlugin };
